'use client';

import { useEffect, useRef } from 'react';
import { motion } from 'motion/react';
import {
  docsNavGroups,
  docsHashPath,
  scrollChildIntoHorizontalTrack,
  scrollToDocsSection,
} from '@/lib/docs-content';
import { useDocsScroll } from '@/components/docs/docs-scroll-context';

export function DocsMobileSectionNav() {
  const { activeSidebarSlug, sidebarProgress } = useDocsScroll();
  const activeRef = useRef<HTMLAnchorElement | null>(null);

  useEffect(() => {
    const pill = activeRef.current;
    const track = pill?.closest<HTMLElement>('.docs-mobile-nav__track');
    if (!pill || !track) return;
    scrollChildIntoHorizontalTrack(pill, track);
  }, [activeSidebarSlug]);

  return (
    <div className="docs-mobile-nav border-line bg-ink/95 sticky top-14 z-30 border-b backdrop-blur-xl xl:hidden">
      <div className="shell py-2">
        <div className="docs-mobile-nav__track flex gap-2 overflow-x-auto pb-1">
          {docsNavGroups.flatMap((group) => group.items).map((item) => {
            const active = activeSidebarSlug === item.slug;

            return (
              <a
                key={item.slug}
                ref={active ? activeRef : null}
                href={docsHashPath(item.slug)}
                onClick={(event) => {
                  event.preventDefault();
                  scrollToDocsSection(item.slug === 'introduction' ? 'introduction' : item.slug);
                }}
                className={`docs-mobile-nav__pill readout shrink-0 px-3 py-1.5 text-[0.6875rem] transition-colors ${
                  active ? 'docs-mobile-nav__pill--active' : ''
                }`}
                aria-current={active ? 'location' : undefined}
              >
                {item.label}
              </a>
            );
          })}
        </div>

        <div className="docs-mobile-nav__progress mt-2 h-px overflow-hidden bg-[color-mix(in_oklab,var(--color-line)_80%,transparent)]">
          <motion.div
            className="docs-mobile-nav__progress-fill bg-accent h-full shadow-[0_0_10px_var(--color-accent)]"
            animate={{ width: `${sidebarProgress * 100}%` }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          />
        </div>
      </div>
    </div>
  );
}
